// extracted by mini-css-extract-plugin
module.exports = {"closeButtonHover":"CloseButton_closeButtonHover__2Yq2c","CloseButton":"CloseButton_CloseButton__zEHZ9"};